module.exports = __webpack_public_path__ + "img/logo-sm.202104212035.a26708d4.jpg";